module.exports = __webpack_public_path__ + "static/media/jacket.41c6f672.png";